import Log from '@/classes/debug/Log'
import recaptchaApi from '@/api/recaptcha/recaptchaApi'

const state = {
  recaptcha: { enabled: false, siteKey: '' }
}

const mutations = {
  setStateRecaptcha: (state, data) => {
    state.recaptcha = { enabled: data.enabled, siteKey: data.site_key }
  }
}

const actions = {
  setupRecaptcha ({ commit }) {
    return recaptchaApi.getRecaptchaConfig().then((response) => {
      commit('setStateRecaptcha', response.data)
      return response.data
    }).catch((err) => {
      Log.debug('Unable to read reCAPTCHA config', err)
      throw err
    })
  }
}

export default {
  state,
  mutations,
  actions
}
